<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path></svg>
</template>
<script>
export default {
    
}
</script>
<style scoped>
    .icon{
         stroke: currentColor;
         height:1rem;
        margin-top:-0.3rem;
        margin-right:0.4rem;
    }
</style>